import { urls } from '@jupiterone/jupiter-web-toolkit/src';
import useJ1AuthFetch from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useJ1AuthFetch';

interface CompressUrlOptions {
  baseUrl: string;
  queryParameters: any;
}

interface CompressUrlResponse {
  url: string;
}
const useUrlShortener = () => {
  const { authFetch } = useJ1AuthFetch();
  async function compressUrl(
    options: CompressUrlOptions
  ): Promise<CompressUrlResponse> {
    const { baseUrl, queryParameters } = options;

    return authFetch(urls.encodeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        baseUrl,
        params: queryParameters,
      }),
    }).then(async (response) => {
      if (response.status >= 400) {
        throw new Error('Error occurred compressing url.');
      } else {
        const json = await response.json();
        return json.data;
      }
    });
  }

  async function decompressParams(encodedParams: string) {
    return authFetch(urls.decodeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        encodedParams,
      }),
    }).then(async (response) => {
      if (response.status >= 400) {
        throw new Error('Error occurred decompressing url parameters.');
      } else {
        const json = await response.json();
        return {
          params: json?.data,
        };
      }
    });
  }
  return {
    compressUrl,
    decompressParams,
  };
};

export default useUrlShortener;
